import React from "react";
import "../src/assets/css/App.css";

// Admin Imports
import Challanges from "views/admin/challenges";
import CreateChallanges from "views/admin/challenges/components/CreateChallenge";
import MyProjects from "views/admin/myProjects";
import ProjectMain from "views/admin/myProjects/components/projectMain";
import McqQuiz from "views/admin/myProjects/components/McqQuiz";
// import Overview from "views/admin/myProjects/components/Overview";
// import Resources from "views/admin/myProjects/components/Resources";
// import Submission from "views/admin/myProjects/components/Submission";
// import Feedback from "views/admin/myProjects/components/Feedback";
import Library from "views/admin/library";
import AllTraining from "views/admin/training";
import TrainingField from "views/admin/training/components/TrainingField";
import Projects from "views/admin/myProjects/teacher_components/Projects";
import ProjectMainTr from "views/admin/myProjects/teacher_components/ProjectMain";
import ProjectMainTrAssign from "views/admin/myProjects/teacher_components/ProjectMainAssign";

// import OverviewTr from "views/admin/myProjects/teacher_components/OverviewTr";
// import Model3d from "views/admin/myProjects/teacher_components/Model3d";
// import SubmissionFeedback from "views/admin/myProjects/teacher_components/FeedBack&Sub";
// import ResourcesTr from "views/admin/myProjects/teacher_components/ResourcesTr";
import LibraryTr from "views/admin/library/teacher_components/Library";
import LibraryPrint from "views/admin/library/teacher_components/LibraryPrint";
import ChallangesTr from "views/admin/challenges/teacher_components/Challenges";
import ChallengeDetails from "views/admin/challenges/teacher_components/ChallengeDetails";
import ChallengeDeAssigned from "views/admin/challenges/teacher_components/ChallengesDeAssigned";
import AddChallange from "views/admin/challenges/teacher_components/AddNewCh";
import EditChallenge from "views/admin/challenges/teacher_components/EditChallenge";
import EditProject from "views/admin/myProjects/teacher_components/EditProject";
import AddProject from "views/admin/myProjects/teacher_components/AddProject";
import Add3dModel from "views/admin/library/teacher_components/Add3dModel";
import Edit3dModel from "views/admin/library/teacher_components/Edit3dModel";
import ModelPrint from "views/admin/library/teacher_components/ModelPrint";
import EditResources from "views/admin/myProjects/teacher_components/EditResources";
import EditQuiz from "views/admin/myProjects/teacher_components/EditQuiz";
import TrainingVoxel from "views/admin/training/components/TrainingVoxel";
import TrainingEdit from "views/admin/training/components/TrainingEdit";
import AddTraining from "views/admin/training/components/AddTraining";
import TrainingDetailsEdit from "views/admin/training/components/TrainingDetailsEdit";
import EditQuizTraining from "views/admin/training/components/EditQuizTraining";
import AccountsManagement from "views/admin/management";

// Auth Imports
import SignIn from "views/auth/SignIn";
import ForgetPass from "views/auth/ForgetPass";
import NotFound from "views/auth/NotFound";
import ResetPass from "views/auth/ResetPass";
import SignUp from "views/auth/signUp";

// Icon Imports
// import { MdLock } from "react-icons/md";
// import challengesIcon from "../src/assets/img/sideBarIcons/challenges.png";
// import projectsIcon from "../src/assets/img/sideBarIcons/My projects.png";
// import libraryIcon from "../src/assets/img/sideBarIcons/Library.png"


const routes = [
  {
    name: "Challenges",
    layout: "/admin",
    path: "challenges",
    component: <Challanges />,
    role: "Student",
  },
  {
    name: "Challenges",
    layout: "/admin",
    path: "challenges/create/:id",
    component: <CreateChallanges />,
    role: "Student",
  },
  {
    name: "My Projects",
    layout: "/admin",
    path: "my-projects",
    component: <MyProjects />,
    secondary: true,
    role: "Student",
  },
  {
    name: "My Projects",
    layout: "/admin",
    path: "my-projects/main:id",
    component: <ProjectMain />,
    secondary: true,
    role: "Student",
  },
  {
    name: "My Projects",
    layout: "/admin",
    path: "my-projects/mcq",
    component: <McqQuiz />,
    secondary: true,
    role: "Student",
  },


  // {
  //   name: "My Projects",
  //   layout: "/admin",
  //   path: "my-projects/overview",
  //   component: <Overview />,
  //   secondary: true,
  //   role: "Student",
  // },
  // {
  //   name: "My Projects",
  //   layout: "/admin",
  //   path: "my-projects/resources",
  //   component: <Resources />,
  //   secondary: true,
  //   role: "Student",
  // },
  // {
  //   name: "My Projects",
  //   layout: "/admin",
  //   path: "my-projects/submission",
  //   component: <Submission />,
  //   secondary: true,
  //   role: "Student",
  // },
  // {
  //   name: "My Projects",
  //   layout: "/admin",
  //   path: "my-projects/feedback",
  //   component: <Feedback />,
  //   secondary: true,
  //   role: "Student",
  // },
  {
    name: "Library",
    layout: "/admin",
    path: "library",
    component: <Library />,
    secondary: true,
    role: "Student",
  },

  /////////// Teacher routes //////////////
  {
    name: "Challenges",
    layout: "/admin",
    path: "tr/challenges",
    component: <ChallangesTr />,
    secondary: true,
    role: "Teacher",
    admin: true,
  },
  {
    name: "Challenges",
    layout: "/admin",
    path: "tr/challenges/details/:id",
    component: <ChallengeDetails />,
    secondary: true,
    role: "Teacher",
    admin: true,
  },
  {
    name: "Challenges",
    layout: "/admin",
    path: "tr/challenges/add",
    component: <AddChallange />,
    secondary: true,
    role: "Teacher",
    admin: true,
  },
  {
    name: "Challenges",
    layout: "/admin",
    path: "tr/challenges/edit/:id",
    component: <EditChallenge />,
    secondary: true,
    admin: true,
  },
  {
    name: "Challenges",
    layout: "/admin",
    path: "tr/challenges/assigned/:id",
    component: <ChallengeDeAssigned />,
    secondary: true,
    admin: true,
    role: "Teacher",
  },


  {
    name: "Projects",
    layout: "/admin",
    path: "tr/projects",
    component: <Projects />,
    secondary: true,
    role: "Teacher",
    admin: true,
  },
  {
    name: "Projects",
    layout: "/admin",
    path: "tr/projects/main/:id",
    component: <ProjectMainTr />,
    secondary: true,
    role: "Teacher",
    admin: true,
  },
  {
    name: "Projects",
    layout: "/admin",
    path: "tr/projects/main/assign/:id",
    component: <ProjectMainTrAssign />,
    secondary: true,
    role: "Teacher",
  },

  {
    name: "Projects",
    layout: "/admin",
    path: "tr/projects/add",
    component: <AddProject />,
    secondary: true,
    admin: true,
  },
  {
    name: "Projects",
    layout: "/admin",
    path: "tr/projects/edit/:id",
    component: <EditProject />,
    secondary: true,
    admin: true,
  },
  {
    name: "Projects",
    layout: "/admin",
    path: "tr/projects/editresources/:id",
    component: <EditResources />,
    secondary: true,
    admin: true,
  },
  {
    name: "Projects",
    layout: "/admin",
    path: "tr/projects/editquiz/:id",
    component: <EditQuiz />,
    secondary: true,
    admin: true,
  },

  // {
  //   name: "Projects",
  //   layout: "/admin",
  //   path: "tr/projects/overview",
  //   component: <OverviewTr />,
  //   secondary: true,
  //   role: "Teacher",
  // },
  // {
  //   name: "Projects",
  //   layout: "/admin",
  //   path: "tr/projects/resources",
  //   component: <ResourcesTr />,
  //   secondary: true,
  //   role: "Teacher",
  // },
  // {
  //   name: "Projects",
  //   layout: "/admin",
  //   path: "tr/projects/3dmodel",
  //   component: <Model3d />,
  //   secondary: true,
  //   role: "Teacher",
  // },
  // {
  //   name: "Projects",
  //   layout: "/admin",
  //   path: "tr/projects/submission&feedback",
  //   component: <SubmissionFeedback />,
  //   secondary: true,
  //   role: "Teacher",
  // },
  {
    name: "Library",
    layout: "/admin",
    path: "tr/library",
    component: <LibraryTr />,
    secondary: true,
    role: "Teacher",
    admin: true,
  },
  {
    name: "Library",
    layout: "/admin",
    path: "tr/library/print/:id",
    component: <LibraryPrint />,
    secondary: true,
    role: "Teacher",
    admin: true,
  },
  {
    name: "Library",
    layout: "/admin",
    path: "tr/library/addmodel",
    component: <Add3dModel />,
    secondary: true,
    admin: true,
  },
  {
    name: "Library",
    layout: "/admin",
    path: "tr/library/modelprint/:id",
    component: <ModelPrint />,
    secondary: true,
    admin: true,
  },
  {
    name: "Library",
    layout: "/admin",
    path: "tr/library/modeledit/:id",
    component: <Edit3dModel />,
    secondary: true,
    admin: true,
  },
  {
    name: "Training",
    layout: "/admin",
    path: "training",
    component: <AllTraining />,
    secondary: true,
    role: "Teacher",
    admin: true,
  },
  {
    name: "Training",
    layout: "/admin",
    path: "training/field/:id",
    component: <TrainingField />,
    secondary: true,
    role: "Teacher",
  },
  {
    name: "Training",
    layout: "/admin",
    path: "training/voxel/:id",
    component: <TrainingVoxel />,
    secondary: true,
    admin: true,
  },
  {
    name: "Training",
    layout: "/admin",
    path: "training/edit/:id",
    component: <TrainingEdit />,
    secondary: true,
    admin: true,
  },
  {
    name: "Training",
    layout: "/admin",
    path: "training/editdetails/:id",
    component: <TrainingDetailsEdit />,
    secondary: true,
    admin: true,
  },
  {
    name: "Training",
    layout: "/admin",
    path: "training/add",
    component: <AddTraining />,
    secondary: true,
    admin: true,
  },
  {
    name: "Training",
    layout: "/admin",
    path: "training/editquiz/:id",
    component: <EditQuizTraining />,
    secondary: true,
    admin: true,
  },

  {
    name: "Accounts",
    layout: "/admin",
    path: "accounts",
    component: <AccountsManagement />,
    secondary: true,
    admin: true,
  },

  /////////// Auth //////////////

  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    component: <SignIn />,
  },
  {
    name: "Forget Password",
    layout: "/auth",
    path: "forget-password",
    component: <ForgetPass />,
  },

  {
    name: "Sign Up",
    layout: "/auth",
    path: `sign-up`,
    component: <SignUp />,
  },

  {
    name: "Reset Password",
    layout: "/auth",
    path: `reset-password/:token`,
    component: <ResetPass />,
  },


  {
    name: "Not Found",
    layout: "/auth",
    path: `not-found`,
    component: <NotFound />,
  },
];
export default routes;
